// extracted by mini-css-extract-plugin
module.exports = {"account-page":"styles_account-page__3E7M6","body":"styles_body__3vDc8","content":"styles_content__1XIvC","paper":"styles_paper__3TxE8"};